<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              
              <v-row dense> 
                <v-col cols="12">
                <v-select outlined hide-details 
                  v-model="editedItem.USEMAIL" :items="STATELIST" :label="$t('common_userinfo_label7')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
              </v-row>
              <v-row dense> 
                <v-col cols="12">
                <v-select outlined hide-details 
                  v-model="editedItem.USETEL" :items="STATELIST" :label="$t('common_userinfo_label6')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
              </v-row>
              <v-row dense> 
                <v-col cols="12">
                <v-select outlined hide-details 
                  v-model="editedItem.USEYEAR" :items="STATELIST" label="생년" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
              </v-row>
              <v-row dense> 
                <v-col cols="12">
                <v-select outlined hide-details 
                  v-model="editedItem.USESEX" :items="STATELIST" :label="$t('common_userinfo_label9')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
              </v-row>
              <v-row dense> 
                <v-col cols="12">
                <v-select outlined hide-details 
                  v-model="editedItem.USEPW" :items="STATELIST" :label="$t('common_userinfo_label8')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
              </v-row>
              <v-row dense> 
                <v-col cols="12">
                <v-select outlined hide-details 
                  v-model="editedItem.USENATION" :items="STATELIST" :label="$t('common_userinfo_label12')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" justify="start" dense>
      <v-col cols="12" md="3" sm="6" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
      <v-col  cols="12" md="3" sm="12" xs="12"  class="pa-0" align="center">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
      <v-col cols="12" md="3" sm="12" xs="12"  class="pa-0" align="center">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:98%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>
    </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        item-key="IDX"
        :loading="loading"
        :items-per-page="9999"
        >
        <template v-slot:header.USEMAIL>
          <label class="cheader_normal" >{{$t("eroption_col1")}}</label>
        </template>
        <template v-slot:header.USETEL>
          <label class="cheader_normal" >{{$t("eroption_col2")}}</label>
        </template>
        <template v-slot:header.USEYEAR>
          <label class="cheader_normal" >{{$t("eroption_col3")}}</label>
        </template>
        <template v-slot:header.USESEX>
          <label class="cheader_normal" >{{$t("eroption_col4")}}</label>
        </template>
        <template v-slot:header.USEPW>
          <label class="cheader_normal" >{{$t("eroption_col5")}}</label>
        </template>
        <template v-slot:header.USENATION>
          <label class="cheader_normal" >{{$t("eroption_col6")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("eroption_col7")}}</label>
        </template>
        
        <template v-slot:item.USEMAIL="{ item }">  
          <label>{{ item.USEMAIL == 1 ? $t('eroption_label1') : $t('eroption_label2') }}</label>
        </template>
        <template v-slot:item.USETEL="{ item }">  
          <label>{{ item.USETEL == 1 ? $t('eroption_label1') : $t('eroption_label2') }}</label>
        </template>
        <template v-slot:item.USEYEAR="{ item }">  
          <label>{{ item.USEYEAR == 1 ? $t('eroption_label1') : $t('eroption_label2') }}</label>
        </template>
        <template v-slot:item.USESEX="{ item }">  
          <label>{{ item.USESEX == 1 ? $t('eroption_label1') : $t('eroption_label2') }}</label>
        </template>
        <template v-slot:item.USEPW="{ item }">  
          <label>{{ item.USEPW == 1 ? $t('eroption_label1') : $t('eroption_label2') }}</label>
        </template>
        <template v-slot:item.USENATION="{ item }">  
          <label>{{ item.USENATION == 1 ? $t('eroption_label1') : $t('eroption_label2') }}</label>
        </template>
        <template v-slot:item.actions="{ item }">  
          <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
export default {
    data: () => ({

      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
      },
      editedItem: {
      },

      STATELIST: [
          {name:'사용안함', name2:"Not used",   value:0}
        , {name:'사용', name2:"USE",       value:1}
      ],

      //테이블 정의
      headers: [
        {text: '이메일',    value: 'USEMAIL', sortable: false, align:'center' },
        {text: '전화번호',   value: 'USETEL', sortable: false, align:'center'},
        {text: '생년',  value: 'USEYEAR', sortable: false, align:'center'},
        {text: '성별',  value: 'USESEX', sortable: false, align:'center'},
        {text: '출력비밀번호',  value: 'USEPW', sortable: false, align:'center'},
        {text: '국가',  value: 'USENATION', sortable: false, align:'center'},
        {text: '수정', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,
      
    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {


      loadpage(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화

        this.loading = true;

          this.$http.post(this.$host+'/api/RegOptionList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              list.forEach(element => {
                  this.itemList.push(element); 
              });
              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      async save () {
        
          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/RegOptionUpdate',{
                USETEL: this.editedItem.USETEL
              , USEYEAR: this.editedItem.USEYEAR
              , USEPW: this.editedItem.USEPW
              , USEMAIL: this.editedItem.USEMAIL
              , USESEX: this.editedItem.USESEX
              , USENATION: this.editedItem.USENATION
              , COM_IDX: this.editedItem.COM_IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
              , EVENT_IDX: this.editedItem.EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        this.close()
      },      

      //검색
      search_run(){
        this.loadpage();
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          

      },

    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>